var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"xiao-fei-zhe-dong-cha"},[_c('PageBlock',{attrs:{"title":"消费者洞察"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"list"},[_c('div',[_vm._v("消费热词")]),_c('div',[_vm._v("性别结构")]),_c('div',[_vm._v("年龄结构")])]),_c('div',{staticClass:"content-list"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }